import { Action } from "@ngrx/store";
import { IServerResponse } from "app/interface";
import {
  DELETE_DOCUMENT_SIGNATURE,
  DELETE_DOCUMENT_SIGNATURE_RESPONSE,
  DOCUMENT_SIGNATURE_BY_FIELD_LIST,
  DOCUMENT_SIGNATURE_BY_ID,
  DOCUMENT_SIGNATURE_LIST,
  GET_DOCUMENT_SIGNATURE_LIST,
  REFRESH_SIGNATURE_STATUS,
  REFRESH_SIGNATURE_STATUS_RESPONSE,
  RESEND_DOCUMENT_SIGNATURE,
  RESEND_DOCUMENT_SIGNATURE_RESPONSE,
  SAVE_DOCUMENT_SIGNATURE,
  SAVE_DOCUMENT_SIGNATURE_RESPONSE,
  SEARCH_DOCUMENT_SIGNATURE_BY_FIELD,
  SEARCH_DOCUMENT_SIGNATURE_BY_ID,
  UPDATE_DOCUMENT_SIGNATURE,
  UPDATE_DOCUMENT_SIGNATURE_RESPONSE,
} from "./actionTypes";

export class GetDocumentSignatureList implements Action {
  readonly type = GET_DOCUMENT_SIGNATURE_LIST;
}

export class DocumentSignatureList implements Action {
  readonly type = DOCUMENT_SIGNATURE_LIST;
  readonly payload = [];
  constructor(documentSignatureList: Array<any>) {
    this.payload = documentSignatureList;
  }
}

export class SearchDocumentSignatureById implements Action {
  readonly type = SEARCH_DOCUMENT_SIGNATURE_BY_ID;
  readonly payload: string = null;
  constructor(id) {
    this.payload = id;
  }
}

export class DocumentSignatureById implements Action {
  readonly type = DOCUMENT_SIGNATURE_BY_ID;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class SearchDocumentSignatureByField implements Action {
  readonly type = SEARCH_DOCUMENT_SIGNATURE_BY_FIELD;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class DocumentSignatureByFieldList implements Action {
  readonly type = DOCUMENT_SIGNATURE_BY_FIELD_LIST;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class SaveDocumentSignature implements Action {
  readonly type = SAVE_DOCUMENT_SIGNATURE;
  readonly payload = null;
  constructor(data) {
    this.payload = data;
  }
}

export class SaveDocumentSignatureResp implements Action {
  readonly type = SAVE_DOCUMENT_SIGNATURE_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(data) {
    this.payload = data;
  }
}

export class UpdateDocumentSignature implements Action {
  readonly type = UPDATE_DOCUMENT_SIGNATURE;
  readonly payload: any = null;
  constructor(data) {
    this.payload = data;
  }
}

export class UpdateDocumentSignatureResponse implements Action {
  readonly type = UPDATE_DOCUMENT_SIGNATURE_RESPONSE;
  readonly payload: any = null;
  constructor(resp: IServerResponse) {
    this.payload = resp;
  }
}

export class DeleteDocumentSignature implements Action {
  readonly type = DELETE_DOCUMENT_SIGNATURE;
  readonly payload = null;
  constructor(id: string) {
    this.payload = id;
  }
}

export class DeleteDocumentSignatureResponse implements Action {
  readonly type = DELETE_DOCUMENT_SIGNATURE_RESPONSE;
  readonly payload: IServerResponse = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class ResendDocumentSignature implements Action {
  readonly type = RESEND_DOCUMENT_SIGNATURE;
  readonly payload = null;
  constructor(id: string) {
    this.payload = id;
  }
}

export class ResendDocumentSignatureResponse implements Action {
  readonly type = RESEND_DOCUMENT_SIGNATURE_RESPONSE;
  readonly payload = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export class RefreshSignatureStatus implements Action {
  readonly type = REFRESH_SIGNATURE_STATUS;
  readonly payload = null;
  constructor(id: string) {
    this.payload = id;
  }
}

export class RefreshSignatureStatusResponse implements Action {
  readonly type = REFRESH_SIGNATURE_STATUS_RESPONSE;
  readonly payload = null;
  constructor(resp) {
    this.payload = resp;
  }
}

export type Actions =
  | GetDocumentSignatureList
  | DocumentSignatureList
  | SearchDocumentSignatureById
  | DocumentSignatureById
  | SaveDocumentSignature
  | SaveDocumentSignatureResp
  | DeleteDocumentSignature
  | DeleteDocumentSignatureResponse
  | SearchDocumentSignatureByField
  | UpdateDocumentSignature
  | UpdateDocumentSignatureResponse
  | DocumentSignatureByFieldList
  | ResendDocumentSignature
  | ResendDocumentSignatureResponse
  | RefreshSignatureStatus
  | RefreshSignatureStatusResponse;
